"use client";
//import cn from "clsx";
import React, { useEffect, useState } from "react";
import HeaderItem from "./headerItem";
import { SectionProps } from "@/components/common/interface/interfaces";
import { Debug } from "@/util/debug";
import { cn } from "@/lib/utils";
import { Flex } from "@radix-ui/themes";
import { checkMobile } from "@/util/checkMobile";

export default function Header(props: SectionProps) {
  const menuList = props.params?.menu?.category_list ?? [];
  const [scrollPosition, setScrollPosition] = useState(0);

  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };
  useEffect(() => {
    window.addEventListener("scroll", updateScroll);
    return () => {
      window.removeEventListener("scroll", updateScroll); //unmount시 해제되도록
    };
  }, []);
  return (
    <header
      className={cn(
        props.className,
        scrollPosition < 60 ? "" : "scrolled",
        "screenAnimation relative flex mx-auto text-center items-center justify-evenly md:justify-between w-full max-w-7xl z-20",
      )}
    >
      <Flex className="absolute top-0 px-4 lg:px-8 py-0 md:pb-1 lg:py-3 pt-8 lg:pt-8 text-center items-center justify-evenly md:justify-between w-full max-w-7xl z-20">
        {menuList.map((item, index) => {
          if ((item.display ?? true) && (item.listview ?? true)) {
            return <HeaderItem key={"header_" + index} item={item} active={item.name == props.params?.menu?.category_id} props={props} />;
          }
        })}
      </Flex>
    </header>
  );
}
